module.exports = __webpack_public_path__ + "img/x-button.1472ae44.svg";